module.exports = __webpack_public_path__ + "static/safari+firefox-d4a39546bda5a84550cb0d82fb281909.png";